export const MainMenuLocalization = {
  FindProductsHeading: $localize`:@@menu.products.heading.find-products:Find Products`,
  BrowseProductsLabel: $localize`:@@menu.products.labels.browse:Browse`,
  AdvancedSearchLabel: $localize`:@@menu.products.labels.advanced-search:Advanced Search`,
  QuickOrderLabel: $localize`:@@menu.products.labels.quick-order:Quick Order`,
} as const;
